import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c5af38ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = { class: "fixed-button__pill" }
const _hoisted_3 = ["src"]

import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { handleAideEntryClick } from '@/views/_components/aide/handle-aide-entry'
import { servicePermission } from '@/common/basis/root-injector'


export default /*#__PURE__*/_defineComponent({
  __name: 'aide-fixed',
  setup(__props) {

const aiIcon = require('./_images/ai-icon.svg')
const router = useRouter()
const { t } = useI18n()

async function onEntryClick () {
  await servicePermission.refreshCurrentTeamPermission()
  handleAideEntryClick({
    router,
    permissionMap: servicePermission.rightsMapData,
    t,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "fixed-button",
    role: "button",
    tabindex: "0",
    title: _ctx.$t('aide.title'),
    "aria-label": _ctx.$t('aide.title'),
    onClick: onEntryClick,
    onKeydown: _withKeys(onEntryClick, ["enter"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(aiIcon),
        class: "fixed-button__icon",
        alt: ""
      }, null, 8, _hoisted_3)
    ])
  ], 40, _hoisted_1))
}
}

})